import React from 'react'


const UserImage = props => {
    return<>
          <img src="images/avatar.png" alt="avatar" className='avatar' />
     </>
}



export default UserImage;